var React = require('react');

function RoundCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 6.5C12 9.81371 9.31371 12.5 6 12.5C2.68629 12.5 0 9.81371 0 6.5C0 3.18629 2.68629 0.5 6 0.5C9.31371 0.5 12 3.18629 12 6.5ZM5.00003 9.50425L2.5 7L3.91421 5.58579L5.00003 6.67504L8.08576 3.58575L9.49997 4.99997L5.00003 9.50425Z","fill":"black"}));
}

RoundCheck.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = RoundCheck;

RoundCheck.default = RoundCheck;
